<template>
    <label :for="(idPrefix ?idPrefix +'_':'')+'input_' +name" class="flex items-start text-left relative" :class="[disabled ? 'pointer-events-none':'']" @mouseover="hover = true" @mouseleave="hover = false">
        <div class="absolute bg-gray-500 h-12 w-12 -top-3.5 -left-4 rounded-full transform" :class="[checked ? 'scale-100 opacity-0 transition-all ease-in-out duration-300' : 'scale-0 opacity-50']"></div>
        <div class="border relative transition-all transform translate-y-1 ease-in-out duration-500 h-3.5 w-3.5 block" :class="[{'opacity-25 cursor-not-allowed':disabled} , isInvert ? 'bg-primary-default' : 'bg-white', inputClass ? inputClass : '' , checked ? (isInvert ? '!bg-primary-default !border-white' : '!bg-primary-default !border-primary-default') :'' , hover && !focused && !hasErrors ? (isInvert ? 'border-white' : 'border-primary-default') : '', hover && focused && !hasErrors || focused && !hasErrors ? 'border-primary-darker' : '', !hover && !hasErrors ? (isInvert ? 'border-white' :'border-gray-200') : '', hasErrors ? 'border-red-500' : '']">
            <div class="pointer-events-none transform rotate-45 border-r-2 border-b-2 border-white w-1 h-2 transition-all transform ease-in-out duration-300 absolute top-0.5 left-1 " :class="[checked ? 'opacity-100' : 'opacity-0']"></div>
            <input :id="(idPrefix ?idPrefix +'_':'')+'input_' +name" type="checkbox" class="absolute w-full h-full top-0 left-0 opacity-0"
                   :checked="checked"
                   @input="(event) => $emit('update:checked', event.target.checked)"
                   :disabled="disabled"
                   :readonly="readonly"
                   :name="name"
            >
        </div>
        <span class="text-sm pl-2" :class="[ this.hasErrors && !hideErrors ? 'text-red-500' : (labelClass ? labelClass : 'text-neutral-default')]">
             <slot/>
        </span>
    </label>
</template>

<script>

    export default {
        data() {
            return {
                focused: false,
                hover: false
            }
        },
        props: {
            idPrefix: {
                type: String,
                required: false
            },
            name: {
                type: String,
                required: false,
                default: ''
            },
            checked: {
                type: Boolean
            },
            readonly: {
                type: Boolean,
                required: false
            },
            validations: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            },
            hideErrors: {
                type: Boolean,
                required: false,
                default: true
            },
            labelClass: {
                type: String,
                required: false,
            },
            inputClass: {
                type: String,
                required: false,
            },
            focus: {
                type: Boolean,
                required: false,
                default: false
            },
            isInvert: {
                type: Boolean
            },
        },
        computed: {
            hasErrors() {
                var hasErrors = false;
                this.validations.forEach(validation => {

                    if (validation.condition) {
                        hasErrors = true;
                        return;
                    }
                })
                return hasErrors;
            }
        },
        methods: {
            onFocus() {
                this.focused = true;
            },
            onBlur() {
                this.focused = false;
            },
            setFocus(fieldName) {
                if (this.name === fieldName) {
                    this.$refs[this.name].focus()
                }
            }
        },
    }
</script>

